/** Mirrors nula_permissions::Permission (camelCase wire values). */
export type PermissionKind =
  | "microphone"
  | "systemAudio"
  | "screenRecording"
  | "accessibility"
  | "inputMonitoring"
  | "calendar"
  | "reminders"
  | "contacts";

/** Mirrors nula_permissions::PermissionStatus (camelCase wire values). */
export type PermissionStatus = "notDetermined" | "denied" | "granted";

const STATUSES = new Set<string>(["notDetermined", "denied", "granted"]);

export function isPermissionStatus(x: unknown): x is PermissionStatus {
  return typeof x === "string" && STATUSES.has(x);
}
